export default __webpack_public_path__ + "static/media/secondPlace.9f08875a.png";